module.exports = __webpack_public_path__ + "img/wollknaul.e891b3e2.png";